import { AnyRecord } from './reduxToolkitUtils';

/**
 * Filters array of objects to have unique items based on some field.
 *
 * Default field prop is `value`
 */
export function createUniqueArray<Item extends AnyRecord>(allValues: Item[], field = 'value') {
    if (!Array.isArray(allValues) || allValues.length === 0) {
        return [];
    }

    const set = new Set();

    return allValues.filter(item => {
        const fieldValue = item[field];
        const valueExists = set.has(fieldValue);

        if (!valueExists) {
            set.add(fieldValue);
        }

        return !valueExists;
    });
}
